import { getRequestGeneric } from "@/services/backendApiGeneric";

// Issue #618: Die Glocke ist bewusst auf Kommunikation beschränkt – nur
// eingehende Nachrichten/E-Mails (Typ "message"), inkl. der im Frontend
// ergänzten, noch nicht zugeordneten Posteingangs-Mails.
export interface NotificationItem {
  type: "message";
  title: string;
  subtitle: string;
  caseId: number;
  caseNumber: string;
  caseDescription: string;
  timeAgo: string;
  icon: string;
  idConversation?: number;
  inboxId?: number;
  // Eskalation: dringende ungelesene Konversationen lösen das rote
  // Pflicht-Popup (UrgentMessageAlert) aus.
  isUrgent?: boolean;
}

// Vertretung (Kundenfeedback Kanzlei 08.09.2026): Nutzer, die der
// Angemeldete heute aktiv vertritt – die Glocke zeigt dazu einen Hinweis.
export interface SubstitutedUser {
  idUser: number;
  name: string;
  validUntil: string | null;
}

export interface NotificationSummary {
  unreadMessages: number;
  total: number;
  items: NotificationItem[];
  substituting?: SubstitutedUser[];
}

export function getNotificationSummary(): Promise<NotificationSummary> {
  return getRequestGeneric("/protected/notifications/summary");
}
